var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            @font-face{font-family:Monorale;font-weight:400;font-style:normal;src:url(/fonts/Monorale-Regular.woff) format(&apos;woff&apos;);font-display:fallback}@font-face{font-family:Monorale;font-weight:500;font-style:normal;src:url(/fonts/Monorale-Medium.woff) format(&apos;woff&apos;);font-display:fallback}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#93A5B2",
    fillRule: "evenodd",
    fontFamily: "Monorale"
  }, /*#__PURE__*/React.createElement("text", {
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 1.333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "SURVEILLANCE")), /*#__PURE__*/React.createElement("text", {
    fontSize: 10,
    letterSpacing: 0.833
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 31
  }, "DASHBOARD")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.d1375c8b.svg";
export { ForwardRef as ReactComponent };